<h5>{{ titleKey | translate }}</h5>
<p *ngIf="descriptionKey" class="description" innerHTML="{{ descriptionKey | translate }}"></p>

<div class="table-responsive">
  <table class="table myip-details">
    <thead>
      <tr>
        <th class="col-select"></th>
        <th class="col-ip">
          {{ 'IPs' | translate }}
          <app-help tooltipKey="IpExceptionExemple" tooltipPlacement="right" />
        </th>
        <th class="col-comment">{{ 'Comments' | translate }}</th>
        <th class="col-actions">Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (ips().length) {
        @for (ip of ips(); track ip.ip ?? $index) {
          <tr>
            <td class="col-select">
              <label *ngIf="!ip.editing" class="ogo-checkbox-container">
                <input (click)="toggleSelected(ip)" [checked]="!!ip.selected" type="checkbox" />
                <span class="ogo-checkbox-checkmark"></span>
              </label>
            </td>
            <td class="col-ip">
              <span *ngIf="!ip.editing">{{ ip.ip }}</span>
              <input
                class="form-control form-control-sm"
                #ipInput
                (keydown)="onKeyDown($event, ip)"
                *ngIf="ip.editing"
                [(ngModel)]="ip.ip"
              />
            </td>
            <td class="col-comment">
              <span *ngIf="!ip.editing" [title]="ip.comment">
                {{ ip.comment }}
              </span>
              <textarea
                (keydown)="onKeyDown($event, ip)"
                *ngIf="ip.editing"
                [(ngModel)]="ip.comment"
                maxlength="255"
                placeholder="{{ 'CommentsOptional' | translate }}"
              ></textarea>
            </td>

            <td class="col-actions">
              <div class="actions-wrapper icon-container">
                @if (!ip.editing) {
                  <button
                    (click)="startIpExceptionEditing(ip)"
                    [disabled]="isEditing()"
                    class="btn btn-transparent p-1 icofont icofont-edit-alt"
                    title="{{ 'Modifier' | translate }}"
                  ></button>
                  <button
                    (click)="deleteIpException(ip)"
                    [disabled]="isEditing()"
                    class="btn btn-transparent p-1 icofont icofont-ui-delete"
                    title="{{ 'supprimer' | translate }}"
                  ></button>
                } @else {
                  <button
                    (click)="validateEdit(ip)"
                    [disabled]="ip.ip.length == 0"
                    [reEnableButton]="busy"
                    class="btn btn-transparent p-1 icofont icofont-check"
                    disableOnClick
                    title="{{ isNew(ip) ? ('ajouter' | translate) : 'Validate' }}"
                  ></button>
                  <button
                    (click)="cancelEdit(ip)"
                    class="btn btn-transparent p-1 icofont icofont-close"
                    title="{{ 'Annuler' | translate }}"
                  ></button>
                }
              </div>
            </td>
          </tr>
        }
      } @else {
        <tr>
          <td [attr.colspan]="4" [ngStyle]="{ padding: '15px' }" class="text-center">
            {{ noneLabel | translate }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="flex-align-items float-left" style="margin-top: 10px">
  <a (click)="ips().length && selectOrDeselectAll()" class="ogo-link mr-3" style="font-weight: bold">{{
    (allSelected() ? 'DeselectAll' : 'SelectAll') | translate
  }}</a>
  <div class="icon-container">
    <i
      (click)="ips().length && copyToClipboard()"
      [ngClass]="ips().length ? [] : ['disabled']"
      class="icofont icofont-ui-copy"
      title="{{ 'CopyList' | translate }}"
    ></i>
    <i
      (click)="!isEditing() && !pasting && pasteFromClipboard()"
      [ngClass]="isEditing() || pasting ? ['disabled'] : []"
      class="icofont icofont-notepad"
      title="{{ 'Paste' | translate }}"
    ></i>
    <i
      (click)="ips().length && downloadCsv()"
      [ngClass]="ips().length ? [] : ['disabled']"
      class="icofont icofont-download"
      title="{{ 'DownloadList' | translate }}"
    ></i>
    <i
      (click)="selectedExceptions().length && !isEditing() && deleteBatchException()"
      [ngClass]="selectedExceptions().length && !isEditing() ? [] : ['disabled']"
      class="icofont icofont-ui-delete"
      title="{{ 'supprimer' | translate }}"
    ></i>
  </div>
</div>
<div class="adding-ips">
  <a (click)="addIpException()" [ngClass]="isEditing() ? 'a-disabled' : ''" class="ogo-link">
    + {{ addLabelKey ?? 'AddAnIPOrCIDR' | translate }}
  </a>
</div>
